import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import {
  downloadFile,

} from "../../utils";
import {
  TRANSACTION_OPTIONS,
} from "../../utils/Enum";
import { useAlert } from "../Alert/AlertContext";
import {
 FormButton,
  FormGroup,
  FormH1,
  FormImg,
  FormImgWrapper,
  FormText,
} from "../CustomForm/CustomFormElements";
import { HoverOption } from "../MenuOptions/MenuOptionsElements";
import { useModal } from "../Modal/ModalContext";
import OptionModal from "../OptionModal";
import WalletSelector from "../QRCodeForm/WalletSelector";



export const SwerlVoucherPurchase = ({ content, type }) => {
  const {
    toggleModal,
    modalContent,
    closeModal,
    openModal,
  } = useModal();
  const { currentUser, getUserPurchases } = useAuth();
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [discount, setDiscount] = useState(0);
  const [total, setTotal] = useState(content?.price ? content.price : 0);

  const confirmPurchase = () => {
    //setCloseButton(false)
    openModal();
    modalContent(
      <>
        <WalletSelector
          heading={`Purchasing (Minting) ${content?.name}`}
          type={TRANSACTION_OPTIONS.PURCHASE_SWERL_VOUCHER}
          body={{
            sender: currentUser?.uid,
            total: discount > 0 ? total - total * (discount / 100) : total,
            months: content?.id,
            instruction: `${
              currentUser?.uid ? currentUser?.uid : "user"
            } is making a payment to mint ${quantity} ${content?.name}`,
            memo: `${
              currentUser?.uid ? currentUser?.uid : "user"
            } is making a payment to mint ${quantity} ${content.name}`,
          }}
          onSuccess={onVoucherPurchaseSuccess}
          cancelQr={() => {
            toggleModal();
            modalContent();
          }}
          onFail={() => {
            toggleModal();
            modalContent();
          }}
        />
      </>
    );
  };

  const onVoucherPurchaseSuccess = (data) => {
    try {
      openModal();
      modalContent(
        <OptionModal
          isOpen={true}
          heading={`The ${content.name} has been purchased`}
        >
          <FormImgWrapper>
            <FormImg src={content.cover?.url} alt={content.name} />
          </FormImgWrapper>

          <HoverOption
            onClick={() => {
              acceptOffers(
                data?.offers,
                data?.offers[0]?.uid,
                data.offers[0].tokenId
              );
            }}
          >
            Claim Token(s) Now
          </HoverOption>
          <HoverOption
            onClick={() => {
              downloadFile(
                `https://xrplexplorer.com/explorer/${data.offers[0]?.tokenId}`
              );
            }}
          >
            View Transaction {data.offers[0].tokenId.substring(0, 15)}...
          </HoverOption>
          <HoverOption
            onClick={() => {
              toggleModal();
              modalContent();
            }}
          >
            Collect Later
          </HoverOption>
        </OptionModal>
      );
    } catch (err) {
      console.error(err);
    }
  };

  const onCollectSuccess = (data) => {
    openModal();
    modalContent(
      <OptionModal
        isOpen={true}
        heading={`The ${content.name} has been claimed!`}
      >
        <FormImgWrapper>
          <FormImg src={content?.cover?.url} alt={content.name} />
        </FormImgWrapper>
        <FormText>
          {" "}
          {`Token ID:  ${data.tokenId.substring(0, 10)}... Minted!`}
        </FormText>
        <HoverOption
          onClick={() => {
            closeModal();
            modalContent();
          }}
        >
          OK
        </HoverOption>
        <HoverOption
          onClick={() => {
            closeModal();
            modalContent();
            navigate(`/nftoken/${data.tokenId}`);
          }}
        >
          View NFToken
        </HoverOption>
        <HoverOption
          onClick={() =>
            navigate(`/musicDownloader`, { preventScrollReset: false })
          }
        >
          Download NFToken Music
        </HoverOption>
        {data?.offers.length > 0 && (
          <HoverOption
            onClick={() =>
              acceptOffers(data?.offers, currentUser?.uid, data.tokenId)
            }
          >
            Collect Next Token Purchase
          </HoverOption>
        )}
      </OptionModal>
    );
  };

  const acceptOffers = (offers, uid, tokenId) => {
    //console.log('AO: ',tokenId.substring(0,5))
    openModal();
    modalContent(
      <WalletSelector
        heading={`Claim ${tokenId.substring(0, 5)}... from the ${
          content.name
        } NFT Collection`}
        type={TRANSACTION_OPTIONS.SWERL_VOUCHER_OFFERS_ACCEPT}
        cancelQr={() => {
          toggleModal();
          modalContent();
        }}
        onFail={() => {
          closeModal();
          modalContent();
        }}
        onSuccess={onCollectSuccess}
        body={{
          collection: content,
          tokenId: tokenId,
          payload: offers[0]?.payload,
          offers: offers,
          sender: currentUser?.uid ? currentUser?.uid : offers[0]?.uid,
          memo: `user is collecting/claiming their voucher ${tokenId.substring(
            0,
            5
          )}...} `,
          instruction: `user is collecting/claiming their voucher ${tokenId.substring(
            0,
            5
          )}...}`,
        }}
      />
    );
  };

  const makePurchase = () => {
    return (
      <OptionModal
        isOpen={true}
        heading={`Purchasing (Minting): ${content.name}`}
        additionalText={
          "You can purchase this voucher with any token of your choice"
        }
        onCancel={() => {
          toggleModal();
          modalContent();
        }}
      >
        {/* <FormInput name={'quantity'} placeholder={"Quantity"} 
          onChange={(e) => {
              handleInput(e) 
              }} type={'number'} min={1} value={quantity}/> */}
        <FormText>
          {" "}
          Total:{" "}
          {parseFloat(content?.price) > 0
            ? `${total} ${content?.currency ? content?.currency : "XRP"}`
            : "FREE"}
        </FormText>
        {content?.price > 0 && (
          <>
            <HoverOption
              onClick={() => {
                modalContent(
                  <>
                    <OptionModal heading={"Coming Soon"}>
                      <HoverOption
                        onClick={() => {
                          openModal();
                          modalContent(
                            <>
                              <SwerlVoucherPurchase content={content} />
                            </>
                          );
                        }}
                      >
                        OK
                      </HoverOption>
                    </OptionModal>
                  </>
                );
              }}
            >
              Purchase As Gift
            </HoverOption>
            <HoverOption
              onClick={() => {
                confirmPurchase();
              }}
            >
              Purchase
            </HoverOption>

            {/* content?.discounts && <HoverOption onClick={() => {
                //getAvailableDiscounts()
            }}>
          Redeem Discount
          </HoverOption> */}
          </>
        )}
      </OptionModal>
    );
  };

  return <>{makePurchase()}</>;
};

